import initImageInput from './imageInput/image-input';
import initTineMce from './tinymce';

export default () => {
  initTineMce();
  initImageInput();
};
